export const UTILITY_DOWNLOAD_ICON = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M14.875 7C14.875 6.37868 15.3787 5.875 16 5.875C16.6213 5.875 17.125 6.37868 17.125 7V19.3042L22.2681 14.896C22.7398 14.4917 23.4497 14.5463 23.854 15.0181C24.2583 15.4898 24.2037 16.1997 23.7319 16.604L16.7319 22.604C16.3106 22.9651 15.6894 22.9651 15.2681 22.604L8.26807 16.604C7.79634 16.1997 7.74168 15.4898 8.146 15.0181C8.55033 14.5463 9.26019 14.4917 9.73193 14.896L14.875 19.3042V7Z"
      fill="currentColor"
    />
    <path
      d="M24 24.875C24.6213 24.875 25.125 25.3787 25.125 26C25.125 26.6213 24.6213 27.125 24 27.125H8C7.37868 27.125 6.875 26.6213 6.875 26C6.875 25.3787 7.37868 24.875 8 24.875H24Z"
      fill="currentColor"
    />
  </svg>
`;
